/**
 * @generated SignedSource<<8853917d40b9895bda9a724e45227895>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedTrendingNowCarouselTabs_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedBestsellingDesignsCarousel_user" | "HpSharedExcellentValuesCarousel_user" | "HpSharedMostSavedItemsCarousel_user">;
  readonly " $fragmentType": "HpSharedTrendingNowCarouselTabs_user";
};
export type HpSharedTrendingNowCarouselTabs_user$key = {
  readonly " $data"?: HpSharedTrendingNowCarouselTabs_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedTrendingNowCarouselTabs_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedTrendingNowCarouselTabs_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HpSharedMostSavedItemsCarousel_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HpSharedExcellentValuesCarousel_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HpSharedBestsellingDesignsCarousel_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "ef7446de79f88afebc69bd7c32649790";

export default node;
